/// <reference path="../../../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../../components.ts"/>

module DealerwareWebComponents {
    "use strict";

    export class WarrantyController {
        public static $inject: string[] = [
            '$mdDialog',
            '$filter',
            '$window',
            '$mobilityCompanyAuthentication',
            '$dealerwareLoading',
            '$dealerwareNotification',
            'PdfHelperService',
            'contract'
        ];

        public location: any;
        public warranty: any;

        constructor(public $mdDialog: any,
                    public $filter: any,
                    public $window: any,
                    public $auth: any,
                    public $dealerwareLoading: any,
                    public $dealerwareNotification: any,
                    public PdfHelperService: any,
                    public contract: any) {
            this.location = this.$auth.location;
            this.location.address = this.parseLocationAddress(this.location.address);
        }

        public get showRemoveButton() : boolean {
            return Object.keys(this.contract.warranty.master).length > 0;
        }

        public get contractDuration() : string {
            var startDate = this.$filter('date')(this.contract.contractDetails.data.actual_pickup, 'M/d/yyyy'),
                endDate = this.$filter('date')(this.contract.contractDetails.data.actual_dropoff, 'M/d/yyyy') || '(currently open)';

            return startDate + ' - ' + endDate;
        }

        public get currencySymbol() : string {
            return this.location.settings.currency_symbol;
        }

        public get dailyRate() : string {
            return this.$filter('currency')(this.contract.warranty.data.daily_rate, this.currencySymbol);
        }

        public set dailyRate(dailyRate: string) {
            this.contract.warranty.data.daily_rate = dailyRate;
        }

        public get warrantySubtotal() : string {
            var warranty = this.contract.warranty.data,
                price = warranty.daily_rate * warranty.warranty_days || 0,
                tax = warranty.tax_percentage / 100 || 0;

            if (!warranty.daily_rate || !warranty.warranty_days) {
                return this.$filter('currency')(0, this.currencySymbol);
            }

            return this.$filter('currency')(
                price + (price * tax),
                this.currencySymbol
            );
        }

        public get warrantyTotal() : string {
            // Eventually, this will actually total things.  For now, just use subtotal.
            return this.warrantySubtotal;
        }

        private parseLocationAddress(address: any) : string {
            return address.street_number + ' ' + address.street_name + ' ' +
                   address.city + ', ' + address.state + ' ' + address.zip;
        }

        public removeWarranty() : void {
            var loader = this.$dealerwareLoading.show('Removing Warranty...');
            this.contract.warranty.$delete({
                promise: true,
                params: {
                    location_id: this.contract.locationId,
                    contract_id: this.contract.contractId
                }
            }).then(
                (response: any) => {
                    this.contract.loadWarranty().finally(() => {
                        loader.close();
                        this.closeModal();
                    });
                },
                (response: any) => {
                    loader.close();
                    this.$dealerwareNotification.apiError(response);
                }
            );
        }

        public closeModal(reset: boolean = false) : void {
            if (reset) { this.resetWarrantyData(); }
            this.$mdDialog.hide();
        }

        public resetWarrantyData() : void {
            var warranty = this.contract.warranty;

            warranty.resetData();

            if (Object.keys(warranty.data).length > 0) {
                warranty.data.daily_rate = parseFloat(warranty.data.daily_rate);
                warranty.data.tax_percentage = parseFloat(warranty.data.tax_percentage) * 100;
                warranty.data.warranty_days = parseFloat(warranty.data.warranty_days);
            }
        }

        public exportWarranty() : void {
            var loader = this.$dealerwareLoading.show('Saving Warranty...');
            this.contract.warranty.$save({
                promise: true,
                params: {
                    location_id: this.contract.locationId,
                    contract_id: this.contract.contractId
                }
            }).then(
                (warranty: any) => {
                    this.contract.warranty = warranty;
                    this.closeModal();
                    this.showWarrantyPdf();
                },
                (response: any) => { this.$dealerwareNotification.apiError(response); }
            ).finally(() => { loader.close(); });
        }

        public showWarrantyPdf() : void {
            var loader = this.$dealerwareLoading.show('Exporting...');
            this.contract.warranty.$getPdf(this.contract).then(
                (response: any) => {
                    loader.close();
                    this.PdfHelperService.streamPdfToNewWindow(response.data);
                }
            );
        }
    }

    getDealerwareWebComponentsModule().controller('WarrantyController', WarrantyController);
}
